import { render, staticRenderFns } from "./AlertsPanel.vue?vue&type=template&id=57139ef6&scoped=true"
import script from "./AlertsPanel.vue?vue&type=script&lang=js"
export * from "./AlertsPanel.vue?vue&type=script&lang=js"
import style0 from "./AlertsPanel.vue?vue&type=style&index=0&id=57139ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57139ef6",
  null
  
)

export default component.exports